import styled from "styled-components";
import { Modal } from "@emonvia/web-components";

export const StyledReevModal = styled(Modal)`
  @media screen and (max-width: 992px) {
    * {
      zoom: inherit;
    }
  }

  > div {
    background-color: ${(props) => props.theme.colors.primaryWhite};
    width: 343px;
    padding: 20px;
    border-radius: 12px;
    gap: 20px;
  }

  .header {
    margin: 0;
  }
  .body {
    font-family: ${(props) => props.theme.fonts.light};
    font-weight: 400;
    line-height: 100%;
    font-size: 16px;
    overflow: hidden;
  }

  .modal-actions {
    margin: 0px;
    flex-direction: column;
    gap: 12px;
  }

  .modal-actions button {
    width: 100%;
    box-shadow: none;
  }

  .modal-actions button [type="ns_20_m"] {
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.medium};
  }

  .modal-actions .secondary-button {
    border-color: ${(props) => props.theme.colors.grey500};
  }

  .modal-actions .secondary-button [type="ns_20_m"] {
    font-family: ${(props) => props.theme.fonts.light};
  }
`;
